var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReposition = function SvgReposition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.012 5 1.993 3h-1.528v3.5h3.533v-1.492l2.99 2-2.99 2V12.5h-3.533V16h1.528l-1.993 3-1.993-3h1.461v-3.5H8.03v1.504l-2.989-2 2.99-2L8.03 11.5h3.45V8h-1.46l1.992-3z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgReposition;